import { FunctionalComponent, h } from '@stencil/core';

export interface ContactHighlightProps {
  elementTitle?: string;
  elementSubtitle?: string;
}

export const ContactHighlight: FunctionalComponent<ContactHighlightProps> = ({ elementTitle, elementSubtitle }) => {
  return <rudy-modules-contact-highlight elementTitle={elementTitle} elementSubtitle={elementSubtitle} />;
};
